export const getAllEnumValues = <T>(enumItem: any): Array<T> => {
  const result = new Array<T>();
  Object.keys(enumItem).filter((item) => {
    if (isNaN(Number(item))) {
      result.push(enumItem[item] as T);
    }
  });
  return result;
};
